import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from '../ui/CtaButton';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/k2C565NJPszKFbuHAQBVUU/WhatsApp_Image_2026-07-20_at_7.16.32_PM.jpg';
const badges = ['PDF Digital', 'Acceso inmediato', 'Principiante → Avanzado'];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CheckCircle2Icon,
  label: 'Pago seguro'
}, {
  icon: StarIcon,
  label: '4.9 rating'
}, {
  icon: MapPinIcon,
  label: 'Todo Argentina'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-blush" data-id="element-135" data-mp="vnnejxqmxwuu">
      <div className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full bg-rose/20 blur-3xl" data-id="element-136" data-mp="10lynm693w3c0" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-rosegold/20 blur-3xl" data-id="element-137" data-mp="15ll36mcepvnz" />

      <div className="relative mx-auto w-full max-w-3xl px-4 py-8 text-center sm:px-6 sm:py-14" data-id="element-138" data-mp="1ak4oqln395ft">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} data-id="element-139" data-mp="9pdv9ptx66ga">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-rosegold/40 bg-white/60 px-3 py-1 text-[9px] font-semibold uppercase tracking-luxe text-rosegold sm:px-4 sm:py-1.5 sm:text-[11px]" data-id="element-140" data-mp="4qstvn2xlgq9">
            🎨 Colorimetría aplicada · resuelta
          </span>

          <h1 className="mx-auto mt-3 max-w-2xl font-display text-[2.45rem] font-semibold leading-[0.94] text-ink sm:mt-5 sm:text-5xl lg:text-6xl" data-id="element-141" data-mp="sdsmoe85fmhm">
            Diagnosticá el Color de Cualquier Clienta en <span className="italic text-rosegold" data-id="element-142" data-mp="imxwwzvp24rf">Menos de 5 Minutos</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.12
      }} className="relative mx-auto mt-5 w-[70%] max-w-[390px] sm:mt-8" data-id="element-143" data-mp="emnhyxpxc40f">
          <div className="absolute inset-0 -rotate-3 rounded-[1.35rem] bg-white/45 sm:rounded-[2rem]" data-id="element-144" data-mp="16cs697gt1b6x" />
          <img src={HERO_IMG} alt="Kit de Colorimetría PRO — ebook digital sobre laptop rodeado de maquillaje" width="1122" height="1600" decoding="async" fetchPriority="high" sizes="(max-width: 640px) 70vw, 390px" className="relative h-auto w-full rounded-[1.35rem] shadow-xl shadow-plum/20 sm:rounded-[2rem] sm:shadow-2xl" data-id="element-145" data-mp="30o0ejp1srog7" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.2
      }} data-id="element-146" data-mp="2musjtoif6cua">
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-plum sm:mt-7 sm:text-lg" data-id="element-147" data-mp="27yt883w3puke">
            Diagnóstico de subtono, armocromía, corrección de color y pieles difíciles. Diagnosticá en menos de 5 minutos, sin errores, en 30 días.
          </p>

          <div className="mx-auto mt-4 max-w-md rounded-2xl border border-rosegold/20 bg-white/80 px-5 py-4 shadow-sm sm:mt-6 sm:px-7 sm:py-5" data-id="element-148" data-mp="b584kzgo4l57">
            <p className="font-display text-2xl font-semibold leading-none text-ink sm:text-3xl" data-id="element-149" data-mp="1vnad76tijhyv">Kit de Colorimetría PRO</p>
            <p className="mt-2 text-[10px] font-medium uppercase tracking-wider text-rosegold sm:text-xs" data-id="element-150" data-mp="25ctuw95hp5s5">
              6 tomos + 6 bonus totalmente gratis
            </p>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-1.5 sm:mt-6 sm:gap-2" data-id="element-151" data-mp="20kael4ff3wjn">
            {badges.map(badge => <span key={badge} className="rounded-full bg-white/70 px-2.5 py-1 text-[10px] font-medium text-plum ring-1 ring-rosegold/20 sm:px-3 sm:text-xs" data-id="element-152" data-mp="2acg66d1rcbyb">
                {badge}
              </span>)}
          </div>

          <div className="mt-5 sm:mt-8" data-id="element-153" data-mp="2jdwf0gcxc60f"><CtaButton fullWidth={false} className="w-full sm:w-auto" data-id="element-154" data-mp="2jaihpmj4amzu">💥 Quiero mi colorimetría resuelta</CtaButton></div>

          <ul className="mx-auto mt-5 grid max-w-lg grid-cols-2 gap-x-3 gap-y-2 text-left sm:mt-8 sm:grid-cols-4 sm:gap-x-4 sm:gap-y-3" data-id="element-155" data-mp="oytw51idrm6h">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-[10px] text-plum sm:gap-2 sm:text-xs" data-id="element-156" data-mp="veu2y7y2yhle">
                <Icon className="h-3.5 w-3.5 shrink-0 text-rosegold sm:h-4 sm:w-4" strokeWidth={1.8} data-id="element-157" data-mp="10e6qkuwrzsp1" />
                {label}
              </li>)}
          </ul>
          <p className="mt-4 text-xs font-medium text-rosegold sm:mt-6 sm:text-sm" data-id="element-158" data-mp="15ano2fpv7jes">+500 maquilladoras ya diagnostican con método</p>
        </motion.div>
      </div>
    </header>;
}